import { HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class DocumentTypeService extends ApiService {
    constructor(http: HttpClient) {
        super(http, 'DocumentType');
      }
}